import React from "react";
import NotFoundImage from "../images/NotFoundImage";
import EmptyBox from "../images/EmptyBox";

function NoDataFound(props) {
  return (
    <div className="w-full h-full flex items-center justify-center flex-col">
      {props.insidePage ? <EmptyBox /> : <NotFoundImage />}
      {/* <NotFoundImage /> */}
      <p>No Data Found</p>
    </div>
  );
}

export default NoDataFound;
